import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

export const getAccumulateData = async (org_id?: string) => {
  const token = localStorage.getItem("token")

  const response = await axios.get(
    `${API_BASE_URL}/data/accumulate/${org_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  console.log(response.data)
  return response.data
}

export const getRecordById = async (id: number) => {
  const token = localStorage.getItem("token")

  const response = await axios.get(
    `${API_BASE_URL}/data/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return response.data
}

export const getBarchartData = async (deviceId: number, startTime: string, endTime: string, resolution: string) => {
  const token = localStorage.getItem("token")

  const response = await axios.get(`${API_BASE_URL}/data/barchart`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: { deviceId, startTime, endTime, resolution },
  });
  return response.data;
};

export const getOneDayStatsByRange = async (deviceId: number, start: string, end: string, days: number[]) => {
  const token = localStorage.getItem("token")

  const daysParam = days.join(',');
  const response = await axios.get(`${API_BASE_URL}/data/one-day-chart`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: { deviceId, start, end, days: `[${daysParam}]` },
  });
  return response.data;
};

export const getCustomTrendByRange = async (conditions: any[], start: string, end: string, resolution: string) => {
  const token = localStorage.getItem("token")

  const response = await axios.get(`${API_BASE_URL}/data/custom-trend`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: {
      conditions: JSON.stringify(conditions),
      start,
      end,
      resolution,
    },
  });
  return response.data;
};

export const getRawDataWithPagination = async (deviceId: number, startDate: string, endDate: string, page: number, limit = 100, sort = "desc") => {
  const token = localStorage.getItem("token")

  const response = await axios.get(`${API_BASE_URL}/data/raw`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: { deviceId, startDate, endDate, limit, page, sort },
  });
  return response.data;
};

export const downloadCsv = async (deviceId: number, startTime: string, endTime: string) => {
  const token = localStorage.getItem("token")
  
  const response = await axios.get(`${API_BASE_URL}/data/download`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: { deviceId, startTime, endTime },
  });
  return response.data;
};